export enum WellbeingQuestionAnswer {
  never = "never",
  rarely = "rarely",
  sometimes = "sometimes",
  often = "often",
  always = "always",
}
